module.exports = {
      id: "icon-info-blue-usage",
      viewBox: "0 0 10 10",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-info-blue",
      toString: function () {
        return this.url;
      }
    }